module.exports = __webpack_public_path__ + "static/media/study 201025.ccc3aea4.png";